module.exports = __webpack_public_path__ + "img/lit_lottery_general.2d589892.png";